import * as types from '../constants/actionTypes';
import objectAssign from 'object-assign';
const initialState = {
	specializationList: [],
	pageContent:[]
};

export default function marketingReducer(state = [], action) {
	
	switch (action.type) {
		case types.GET_MARKETING_SPECIALIZATION:
			return objectAssign({}, state, {
				specializationList: action.specializationList
			});
		case types.GET_MARKETING_SPECIALISTS_LIST:
			return objectAssign({}, state, {
				specialistList: action.specialistList
			});
		case types.GET_MARKET_OTHER_CONSULTATION_ADDRESS:
			return objectAssign({}, state, {
				otherConsultationAddress: action.otherConsultationAddress
			});
		case types.GET_CMS_PAGE_CONTENT:
			return objectAssign({}, state, {
				pageContent: action.pageContent
			});

		default:
			return state;
	}
}

